import { useAuth } from '@clerk/clerk-react';
import useSWR from 'swr';
import { spacesApi } from '@/lib/api';
import { AUDIT_PAGE_SIZE } from '@/lib/spaces/audit';
import { VOLATILE_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

export function useSpaceAudit(spaceId: string, offset: number) {
  const { userId } = useAuth();
  const fetch = useAuthedFetcher();
  return useSWR(userId ? ['space-audit', userId, spaceId, offset] : null,
    () => fetch((token) => spacesApi.audit(token, spaceId, offset, AUDIT_PAGE_SIZE)),
    { ...VOLATILE_SWR_OPTIONS, shouldRetryOnError: false });
}
